export const SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

export const APPEARANCES = {
  default: 'default',
  searchable: 'searchable',
  autocomplete: 'autocomplete',
};

export const SEARCHABLE_APPEARANCES = ['searchable', 'autocomplete'];
